import BaseApi from './BaseApi';

import { ChangePasswordProps, NotificationProps } from 'models';

class UserSettingsApi extends BaseApi {
	constructor() {
		super('/investor/settings');
	}

	get() {
		return this.httpClient.get({ conditions: { auth: true } });
	}

	update(body: any) {
		return this.httpClient.put({ conditions: { auth: true }, body });
	}

	changePassword(body: ChangePasswordProps) {
		return this.httpClient.put({ conditions: { auth: true }, url: '/change-pass', body });
	}

	notification(body: NotificationProps) {
		return this.httpClient.patch({
			conditions: { auth: true, version: 'v2' },
			url: '/notifications-batch',
			body,
		});
	}

	sessionConfig(payload: { type: string; param?: string }) {
		return this.httpClient.patch({
			conditions: { auth: true, version: 'v2' },
			url: `/session-ttl/${payload.type}`,
			body: payload?.param && {
				param: payload.param
			},
		});
	}
}

export const UserSettingsService = new UserSettingsApi();
